import {
	Referrals,
	ReferralStatusEnum,
} from 'domain/usecases/private/my-referrals-flow/get-referrals';
import React, {useState} from 'react';
import {useTheme} from '@mui/material';
import {ContentListProps} from 'presentation/components/StyledCard/types';
import {format, parseISO} from 'date-fns';
import {textHandle} from 'presentation/utils/textHandle';
import {translations} from 'presentation/translations-new';
import providerNameIcon from 'presentation/assets/images/icon-nome-prestador.png';

import {useHostName} from 'presentation/hooks';
import {useMediaQueries} from 'presentation/pages/private/hooks';
import {cardStyleByStatus} from '../constants/cardByStatus';
import {UNITS_CHANNELS_CONTACTS} from 'presentation/modules/booking/shared/constants/unitsChannelsContacts';

const {procedure, requestedAt, protocol} = translations['pt-br'].commons;
const {providerName} = translations['pt-br'].privateFlow.myReferrals;
export const useReferralCard = (data: Referrals) => {
	const {dataHostNameState} = useHostName();
	const theme = useTheme();
	const {borderColor, chipText, chipVariant, chipTextColor} = cardStyleByStatus(
		theme,
		data.status,
	);
	const shouldHideProtocol = data.status === ReferralStatusEnum.REJECTED;
	const shouldHideDetailsButton = data.status !== ReferralStatusEnum.SUCCESS;
	const [anchorElState, setAnchorElState] = useState<null | HTMLElement>(null);
	const [openPhoneDrawerState, setOpenPhoneDrawerState] = useState<boolean>(false);
	const phoneNumbers = UNITS_CHANNELS_CONTACTS[dataHostNameState.product];
	const {isMobile} = useMediaQueries();
	const isPhoneNumberMenuOpen = Boolean(anchorElState);
	const handleTogglePhoneDrawer = () => {
		setOpenPhoneDrawerState(prev => !prev);
	};

	const handleOpenPhoneMenu = (event: React.MouseEvent<HTMLButtonElement>) => {
		if (isMobile) {
			setOpenPhoneDrawerState(true);
			return;
		}
		setAnchorElState(event.currentTarget);
	};
	const handleClosePhoneMenu = () => {
		setAnchorElState(null);
	};

	const contentList: ContentListProps[] = [
		{
			iconName: 'stethoscope',
			primaryText: procedure,
			secondaryText: textHandle(data?.tipoProcedimento).capitalizeFirstLetter() ?? '',
			primaryTextColor: 'text.secondary',
			primaryTextFontSize: '0.875rem',
			secondaryTextFontSize: '1rem',
		},
		{
			iconName: 'event-filled',
			primaryText: requestedAt,
			secondaryText: data?.dtSolicitacao
				? format(parseISO(data.dtSolicitacao), 'dd/MM/yyyy')
				: '--/--/----',
			primaryTextColor: 'text.secondary',
			primaryTextFontSize: '0.875rem',
			secondaryTextFontSize: '1rem',
		},
	];
	if (data.nomePrestador) {
		contentList.splice(1, 0, {
			iconName: 'article-person-filled',
			customIcon: <img src={providerNameIcon} alt="" width={20} height={20} />,
			primaryText: providerName,
			secondaryText: textHandle(data.nomePrestador).capitalize(),
			primaryTextColor: 'text.secondary',
			primaryTextFontSize: '0.875rem',
			secondaryTextFontSize: '1rem',
		});
	}
	if (!shouldHideProtocol) {
		contentList.push({
			iconName: 'assignment-filled',
			primaryText: protocol,
			secondaryText: data?.protocoloSolicitacao?.trim() || data?.protocolo || '',
			primaryTextColor: 'text.secondary',
			primaryTextFontSize: '0.875rem',
			secondaryTextFontSize: '1rem',
		});
	}

	return {
		contentList,
		theme,
		borderColor,
		chipText,
		chipVariant,
		chipTextColor,
		shouldHideDetailsButton,
		shouldHideProtocol,
		anchorElState,
		dataHostNameState,
		setAnchorElState,
		isMobile,
		isPhoneNumberMenuOpen,
		phoneNumbers,
		openPhoneDrawerState,
		handleTogglePhoneDrawer,
		setOpenPhoneDrawerState,
		handleOpenPhoneMenu,
		handleClosePhoneMenu,
	};
};
